export const FINANCE_PAYMENTS_COLUMNS = [
  {
    name  : 'id',
    label : 'ID',
  },
  {
    name  : 'payments.created_at',
    label : 'Created At',
  },
  {
    name  : 'payments.paid_at',
    label : 'Paid At',
  },
  {
    name  : 'payments.reference_number',
    label : 'Payments Reference Number',
  },
  {
    name  : 'deals.reference_number',
    label : 'Deals Reference Number',
  },
  {
    name  : 'users.email',
    label : 'User Email',
  },
  {
    name  : 'user_details.name',
    label : 'User Full Name',
  },
  {
    name  : 'deals.final_payment',
    label : 'Final Payment',
  },
  {
    name  : 'deals.down_payment',
    label : 'Down Payment',
  },
  {
    name  : 'deals.state',
    label : 'State',
  },
]